export default [
    {
        code: 'STRIVE',
        name: 'STRIVE',
    },
    {
        code: 'External',
        name: 'External',
    },
    {
        code: 'HSC',
        name: 'AthCap',
    },
    {
        code: 'db',
        name: 'DB',
    }
]